import {Event} from "@app/core/tracking/domain/event";
/**
 * Event indicating that a user went idle.
 * This event is used to track periods of inactivity in the application.
 */
export class UserWentIdleEvent extends Event {
}